import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import {
    Box,
    IconButton,
    Typography,
} from '@mui/material';
import {
    AddCircleOutline,
    Cancel,
    Check,
    Undo,
} from '@mui/icons-material';

import PermissionGuard, { HasPermissions } from '../../contexts/PermissionContext';
import SecondaryButton from '../buttons/SecondaryButton';
import SettingsTextField from '../textfield/SettingsTextField';
import SettingsChipTextField from '../textfield/SettingsChipTextField';


function VFXVendorsSettings({ schema={}, settings={}, setSettings = () => {} }) {

    const [vfxVendorsSettings, setVfxVendorsSettings] = useState(settings);

    useEffect(() => {
        setVfxVendorsSettings(settings)
    }, [settings])

    function handleChange(field, value) {
        const updatedSettings = _.cloneDeep(vfxVendorsSettings);
        updatedSettings[field] = value;
        updateSettings(updatedSettings);
    }

    function handleDiscard() {
        updateSettings(settings);
    }

    function updateSettings(newSettings) {
        setVfxVendorsSettings(newSettings);
        setSettings(newSettings);
    }

    return (
        <Box
            display="flex"
            border={'1px solid rgba(139, 142, 146, 1)'}
            borderRadius={4}
            position="relative"
        >
            {/* {
                !_.isEqual(settings, vfxVendorsSettings) && 
                <Box
                    position="absolute"
                    top={0}
                    right={0}
                    p={1}
                >
                    <IconButton
                        sx={{
                            color: 'rgba(180, 120, 120, 0.7)', // muted red
                            transition: 'color 0.2s',
                            '&:hover': {
                                color: 'rgb(211, 47, 47)', // vivid red
                            },
                        }}
                        onClick={handleDiscard}
                    >
                        <Undo
                            sx={{
                                fontSize: '16px',
                            }}
                        />
                    </IconButton>
                    <IconButton
                        sx={{
                            color: 'rgba(120, 180, 120, 0.7)', // muted green
                            fontSize: '16px',
                            transition: 'color 0.2s',
                            '&:hover': {
                                color: 'rgb(46, 225, 50)', // vivid green
                            },
                        }}
                    >
                        <Check
                            sx={{
                                fontSize: '16px',
                            }}
                        />
                    </IconButton>
                </Box>
            } */}
            <Box
                m={2}
                display="flex"
                flexDirection="column"
                gap={2}
                width='100%'
            >
                <Typography
                    variant="h6"
                >
                    VFX Vendors
                </Typography>
                <Box
                    display="flex"
                    flexDirection="column"
                    p={1}
                    sx={{
                        border: '1px solid rgba(92, 92, 92, 1)',
                        borderRadius: 3,
                        '&:hover': {
                            border: HasPermissions(schema?.permissions?.write) && '1px solid rgba(139, 142, 146, 1)'
                        },
                        transition: 'border 0.15s ease-out',
                    }}
                >
                    <SettingsChipTextField
                        description={`List of email addresses to receive all Illusion notifications.`}
                        disabled={!HasPermissions(schema?.permissions?.write)}
                        label='Global Email Addresses'
                        onChange={(values) => handleChange('notifications', {...vfxVendorsSettings?.notifications, email: values})}
                        original={settings?.notifications?.email ?? []}
                        values={vfxVendorsSettings?.notifications?.email ?? []}
                    />
                </Box>
                {
                    (vfxVendorsSettings?.vendors ?? []).map((vendor, index) => (
                        <Box
                            key={index}
                            position="relative"
                            display="flex"
                            flexDirection="column"
                            p={1}
                            sx={{
                                border: '1px solid rgba(92, 92, 92, 1)',
                                borderRadius: 3,
                                '&:hover': {
                                    border: HasPermissions(schema?.permissions?.write) && '1px solid rgba(139, 142, 146, 1)'
                                },
                                transition: 'border 0.15s ease-out',
                            }}
                        >
                            <PermissionGuard permission={schema?.permissions?.write || []}>
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        zIndex: 1,
                                    }}
                                >
                                    <SecondaryButton
                                        onClick={() => {
                                            handleChange('vendors', vfxVendorsSettings?.vendors?.filter((_, i) => i !== index));
                                        }}
                                        color='rgba(92, 92, 92, 1)'
                                        hoverColor='rgba(222, 155, 145, 1)'
                                        icon={<Cancel />}
                                    />
                                </Box>
                            </PermissionGuard>
                            <SettingsTextField
                                description={`Name of the VFX vendor #${index + 1}.`}
                                disabled={!HasPermissions(schema?.permissions?.write)}
                                label='Vendor Name'
                                onChange={(value) => handleChange('vendors', vfxVendorsSettings?.vendors?.map((v, i) => i === index ? {...v, name: value} : v))}
                                original={settings?.vendors?.[index]?.name ?? ''}
                                value={vendor?.name ?? ''}
                            />
                            <SettingsTextField
                                description={`Short name of the VFX vendor. This will likely be a component in the file path in your storage solution.`}
                                disabled={!HasPermissions(schema?.permissions?.write)}
                                label='Vendor Short Name'
                                onChange={(value) => handleChange('vendors', vfxVendorsSettings?.vendors?.map((v, i) => i === index ? {...v, short: value} : v))}
                                original={settings?.vendors?.[index]?.short ?? ''}
                                value={vendor?.short ?? ''}
                            />
                            <SettingsChipTextField
                                description={`List of email addresses for ${vendor?.name ?? 'vendor'} notifications.`}
                                disabled={!HasPermissions(schema?.permissions?.write)}
                                label='Email Addresses'
                                onChange={(values) => handleChange('vendors', vfxVendorsSettings?.vendors?.map((v, i) => i === index ? {...v, email: values} : v))}
                                original={settings?.vendors?.[index]?.email ?? []}
                                values={vendor?.email ?? []}
                            />
                        </Box>
                    ))
                }
                <PermissionGuard permission={schema?.permissions?.write || []}>
                    <Box
                        display='flex'
                        justifyContent='center'
                    >
                        <SecondaryButton
                            onClick={() => {
                                handleChange('vendors', [...(vfxVendorsSettings?.vendors ?? []), {name: '', short: '', email: []}]);
                            }}
                            color='rgba(92, 92, 92, 1)'
                            hoverColor='rgba(255, 255, 255, 1)'
                            icon={<AddCircleOutline sx={{ fontSize: '35px' }} />}
                        />
                    </Box>
                </PermissionGuard>

            </Box>
        </Box>
    );
}

export default VFXVendorsSettings;